export default __webpack_public_path__ + "static/ap-755b811ff3b3feb12ab36e0db606ff43.png";